<footer>
    <!-- <div class="imgArea">
		<div class="imgBox">
			<img
				src="/assets/images/footer-logo.png"
				alt=""
				width="100%"
			/>
		</div>
	</div> -->
    <div class="bottomArea" [ngClass]="{ 'bottomArea-english': isEnglish() }">
        <div class="imgBox">
            <img class="footerLogo" src="/assets/images/footer-logo.png" alt="" />
            <div class="contactBox">
                <h3>{{ 'footer.contactInfo.info' | translate }}</h3>
                <p>service@kunyoutech.com.tw</p>
                <p>{{ 'footer.contactInfo.address' | translate }}</p>
                <p>+886 2 2325 5956</p>
                <p>{{ 'footer.contactInfo.businessHours' | translate }}</p>
                <img
                    src="/assets/images/linkedin-logo.png"
                    alt=""
                    class="linkedinLogo"
                    (click)="openLinkedinWeb()" />
            </div>
        </div>
        <div class="sitemapBox" [ngClass]="{ 'sitemapBox-english': isEnglish() }">
            <div class="chapter" [ngClass]="{ 'chapter-english': isEnglish() }">
                <h4>
                    {{ 'footer.services.item.productsAndServices' | translate }}
                </h4>
                <nav>
                    <a
                        [routerLink]="['/products']"
                        [queryParams]="{ keyword: 'big-data' }"
                        title="前往大數據產品搜尋">
                        {{ 'footer.services.option.bigData' | translate }}
                    </a>
                    <a
                        [routerLink]="['/products']"
                        [queryParams]="{ keyword: 'iot' }"
                        title="前往物聯網產品搜尋">
                        {{ 'footer.services.option.internetofThings' | translate }}
                    </a>
                    <a
                        [routerLink]="['/products']"
                        [queryParams]="{ keyword: 'ai' }"
                        title="前往人工智慧產品搜尋">
                        {{
                            'footer.services.option.artifiialIntelligence'
                                | translate
                        }}
                    </a>
                    <a
                        [routerLink]="['/products']"
                        [queryParams]="{ keyword: 'info-security' }"
                        title="前往資訊安全產品搜尋">
                        {{
                            'footer.services.option.informationSecurity' | translate
                        }}
                    </a>
                    <a
                        [routerLink]="['/products']"
                        [queryParams]="{ keyword: 'data-consolidation' }"
                        title="前往數據整合產品搜尋">
                        {{ 'footer.services.option.dataIntegration' | translate }}
                    </a>
                    <a
                        [routerLink]="['/products']"
                        [queryParams]="{ keyword: 'technical-support' }"
                        title="前往技術支援產品搜尋">
                        {{ 'footer.services.option.technicalSupport' | translate }}
                    </a>
                </nav>
            </div>
            <div class="chapter" [ngClass]="{ 'chapter-english': isEnglish() }">
                <h4>{{ 'footer.services.item.solutions' | translate }}</h4>
                <nav>
                    <a
                        routerLink="/solutions/explore/investForensics"
                        title="前往科技偵查與數位鑑識解決方案">
                        {{ 'footer.services.option.techInvestigationDigitalForensics' | translate }}
                    </a>
                    <a
                        routerLink="/solutions/explore/securityMonitor"
                        title="前往智慧安防與場域監控解決方案">
                        {{ 'footer.services.option.smartSecurityFieldMonitoring' | translate }}
                    </a>
                    <a
                        routerLink="/solutions/explore/intelGovern"
                        title="前往情資整合與智慧治理解決方案">
                        {{
                            'footer.services.option.intelIntegrationSmartGovernance'
                                | translate
                        }}
                    </a>
                    <a
                        routerLink="/solutions/explore/logisticsTransport"
                        title="前往智慧物流與運輸管理解決方案">
                        {{
                            'footer.services.option.smartLogisticsTransportMgmt'
                                | translate
                        }}
                    </a>
                    <a
                        routerLink="/solutions/explore/coreOpsHR"
                        title="前往核心營運與人事管理解決方案">
                        {{
                            'footer.services.option.coreOpsHRManagement'
                                | translate
                        }}
                    </a>
                </nav>
            </div>
            <div class="chapter" [ngClass]="{ 'chapter-english': isEnglish() }">
                <h4>{{ 'footer.services.item.about' | translate }}</h4>
                <nav>
                    <a [routerLink]="['/aboutKunYu']" title="前往公司簡介">
                        {{ 'footer.services.option.companyProfile' | translate }}
                    </a>
                    <a [routerLink]="['/corporatePhilosophy']" title="前往企業理念">
                        {{
                            'footer.services.option.corporatePhilosophy' | translate
                        }}
                    </a>
                </nav>
            </div>
            <div class="chapter" *ngIf="!isEnglish()">
                <h4>新聞中心</h4>
                <nav>
                    <a
                        [routerLink]="['/newsCenter']"
                        [queryParams]="{ newsType: 2 }"
                        newsType
                        title="前往新聞與活動">
                        新聞與活動
                    </a>
                    <a
                        [routerLink]="['/newsCenter']"
                        [queryParams]="{ newsType: 3 }"
                        title="前往電子報">
                        電子報
                    </a>
                </nav>
            </div>
            <div class="chapter" *ngIf="!isEnglish()">
                <h4>人才招募</h4>
                <nav>
                    <a [routerLink]="['/humanRecruit']" title="前往加入坤侑">
                        加入坤侑
                    </a>
                </nav>
            </div>
            <div class="chapter" [ngClass]="{ 'chapter-english': isEnglish() }">
                <h4>{{ 'footer.services.item.psirt' | translate }}</h4>
                <nav>
                    <a [routerLink]="['/psirt']" title="前往安全漏洞回報">
                        {{ 'footer.services.option.psirt' | translate }}
                    </a>
                </nav>
            </div>
        </div>
    </div>
    <div class="horizontal-divider"></div>
    <div class="copyrightInfo">
        <div class="links">
            <a href="" [routerLink]="['/copyright']" title="前往網站著作權聲明">
                {{ 'footer.copyrightNotice.title' | translate }}
            </a>
            ｜
            <a href="" [routerLink]="['/privacy']" title="前往網站隱私權保護聲明">
                {{ 'footer.privacyPolicy.title' | translate }}
            </a>
            ｜
            <a href="" [routerLink]="['/infoSecurity']" title="前往資訊安全政策宣告">
                {{ 'footer.infoSecurity.title' | translate }}
            </a>
        </div>
        <div class="claim">
            <p>{{ 'footer.copyright' | translate }}</p>
        </div>
    </div>
</footer>
